export default "__VITE_ASSET__CuRNYM8y__"